import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { SorCodeOverride } from "@app/models/rest/sor-code-override";

@Injectable({
  providedIn: "root"
})
export class SorCodeOverrideRestService extends HateoasResourceOperation<SorCodeOverride> {
  constructor() {
    super(SorCodeOverride);
  }
}
